import { inject, Component, EventEmitter, Input, Output } from '@angular/core';
import { StackedListConfig, StackedListItem, StackedListItemType } from './stackedlist.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { LucideDynamicIcon } from '@lucide/angular';

@Component({
  selector: 'app-stackedlist',
  templateUrl: './stackedlist.component.html',
  imports: [LucideDynamicIcon],
})
export class StackedListComponent {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  actionClasses = 'text-xs text-zinc-800 hover:text-zinc-400';

  @Input() config: StackedListConfig = {
    items: [],
  };

  @Output() rowclick = new EventEmitter<StackedListItem>();

  rowclicked(menuItem: StackedListItem, event: any) {
    if (event) {
      event.stopPropagation();
    }
    if (menuItem.type === StackedListItemType.Callback) {
      this.rowclick.emit(menuItem);
    } else if (menuItem.type === StackedListItemType.Path) {
      const currentQueryParams = this.activatedRoute.snapshot.queryParams;
      this.router.navigate([menuItem.id], { state: { previousQueryParams: currentQueryParams } });
    }
  }
}
